var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hollow-dots-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }